import welcome from '../assets/360/welcome.jpg'
import classroom from '../assets/360/classroom.jpg'
import computerla from '../assets/360/computerla.jpg'
import welding from '../assets/360/welding.jpg'
import brickAndStone from '../assets/360/brickAndStone.jpg'
import strcutureforming from '../assets/360/strcutureforming.jpg'
import bridgeConstruction from '../assets/360/bridgeConstruction.jpg'
import miniexcavator from '../assets/360/miniexcavator.jpg'
import tileSetter from '../assets/360/tileSetter.jpg'
import cementFinisher from '../assets/360/cementFinisher.jpg'
import asphalt from '../assets/360/asphalt.jpg'
import tunnelRescue from '../assets/360/tunnelRescue.jpg'
import mobileCrane from '../assets/360/mobileCrane.jpg'
import highRiseFormingRodman from '../assets/360/highRiseFormingRodman.jpg'

export const assetsPath = `https://www.183training.com/virtual-tour/`

const locations = {
    "WELCOME": {
        position: {
            largeScreen: {
                x: 541.285,
                y: 232.236
            },
            mobilePortrait: {
                x: 221.39,
                y: 151.76
            },
            mobileLandscape: {
                x: 424.13,
                y: 108.185
            }

        },
        description: "Welcome to LiUNA Local 183’s Vaughan campus, our largest training campus! Servicing both union members and individuals looking for a career in construction, our 44,000 square feet of indoor and outdoor training space offer state-of-the-art programs in Health and Safety and Construction Skills, as well as  four apprenticeships in Construction Craft Worker, Brick and Stone Masonry, Cement Finishing, and Tractor Loading Backhoe. Our programs provide students with the necessary theory and hands-on skills they need to start their career in the construction industry.",
        bulletPoints: [
            'Our Vaughan campus is our largest LiUNA Local 183 Training campus',
            'The bulk of our programs are run out of this facility, programs that include Health and Safety, Construction Skills, and our 4 Apprenticeship programs.',
            'The campus is located at 8700 Huntington Road in Vaughan Ontario and services members of the union as well as other individuals looking for a career in construction.',
            'It is over 44, 000 square feet of indoor training space as well as outdoor training locations.',
            'A state-of-the-art facility that can train our students in the practical and the hands-on theory they will need when starting their career in the construction industry.',
        ],
        imgDirectory: "Welcome",
        numberOfImgs: 1,
        img360: welcome
    },
    "CLASSROOMS": {
        position: {
            largeScreen: {
                x: 511.025,
                y: 242.305
            },
            mobilePortrait: {
                x: 207.386,
                y: 167.124
            },
            mobileLandscape: {
                x: 403.354,
                y: 109.095
            }
        },
        description: "Our Vaughan campus includes five classrooms where trainees can receive mandatory Health and Safety training to protect themselves – and each other – on the jobsite. Each classroom is equipped with its own Working at Heights kit for twelve students. These kits ensure the safety of our students in the classroom and expose them to the necessary safeguards they will use on the jobsite.",
        bulletPoints: [
            'We have 5 classrooms located inside our Vaughan campus.',
            'Trainees can receive mandatory health and safety training they require to be safe on the jobsite.',
            'Each classroom is equipped with its own Working at Heights kit for 12 students.'
        ],
        imgDirectory: "Classrooms",
        numberOfImgs: 1,
        img360: classroom
    },
    "COMPUTER LAB": {
        position: {
            largeScreen: {
                x: 530.481,
                y: 294.196
            },
            mobilePortrait: {
                x: 234.979,
                y: 190.44
            },
            mobileLandscape: {
                x: 406.288,
                y: 145.01
            }
        },
        imgDirectory: "ComputerLab",
        numberOfImgs: 4,
        description: "Our computer lab offers ten computers for students to complete online training, as well as two equipment simulators. These allow students to  practice working with  small machines before using the actual equipment. They can gain experience on machines in a safe and controlled setting, including the mini excavator, the forklift, and the 0-8 ton boom lift.",
        bulletPoints: [
            'There are 10 computers in the computer lab where students can complete online training.',
            'We recently added two equipment simulators, where students can gain experience on our small machines (Mini excavator, forklift and 0-8 ton Boom lift) before training on the actual equipment.  This is a great way for students to gain experience in a safe and controlled setting.'
        ],
        img360: computerla
    },
    "WELDING ROOM": {
        position: {
            largeScreen: {

                x: 423.616,
                y: 272.913
            },
            mobilePortrait: {
                x: 167.42,
                y: 212.37
            },
            mobileLandscape: {
                x: 343.091,
                y: 112.678
            }
        },
        imgDirectory: "WeldingRoom",
        numberOfImgs: 4,
        description: "Our upgraded welding room is a dedicated and fully-ventilated workspace equipped with twelve stalls, where we safely train our students on flat, horizontal, vertical, and overhead welding. The welding room is confined and separated from our other workspaces, ensuring that no other students are exposed to any of the arc flashes or fumes. In order to certify our trainees, we partner with the Canadian Welding Bureau, one of the most innovative welding organizations in the world that provides welding certification, management systems registration, and training services.",
        learnMore: {
            label: 'Learn more about our Welding programs.',
            link: 'https://www.183training.com/construction-skills-programs/#courses',
        },
        bulletPoints: [
            'Upgraded welding room is equipped with 12 stalls.',
            'This workspace is fully dedicated to our welding program, where we can train our students in a confined area for the safety of the students, they are able to focus on the four types of welding that we teach which includes flat, horizontal, vertical, and overhead.',
            'Because the welding workspace is separate from our other workspaces, we can ensure that no one is exposed to any of the arch flashes or fumes. The workshop is fully ventilated to keep our welding trainees safe from harmful fumes.',
            'We partner with the Canadian Welding Bureau to certify our trainees.'
        ],
        img360: welding
    },
    "BRICK + STONE WORKSPACE": {
        position: {
            largeScreen: {
                x: 454.626,
                y: 356.951
            },
            mobilePortrait: {
                x: 211.822,
                y: 250.291
            },
            mobileLandscape: {
                x: 347.527,
                y: 170.899
            }
        },
        imgDirectory: "BrickStone",
        numberOfImgs: 5,
        size: 'Workshop #1 - 4,000 sq. ft.',
        description: `Workshop #1 holds our dedicated workspace for the Brick and Stone apprenticeship. It features designated areas for line work, setting up scaffolding, and mixing and preparing mortar – everything our students need to simulate the work typically done on a real-world job site. They work with brick, stone, and block to build full-sized structures like fireplaces, archways, and chimneys.`,
        learnMore: {
            label: 'Learn more about our Brick and Stone apprenticeship.',
            link: 'https://www.183training.com/course/brick-stone-masonry-level-1'
        },
        bulletPoints: [
            'Dedicated to our Brick and Stone Apprenticeship',
            'A designated area of this workspace is dedicated to line work as well as setting up scaffolding to simulate the work typically done on a job site.',
            'We work with both brick, stone, and block with our apprentices.',
            'There is an area designated to mix and prepare mortar.',
            'Apprentices can build full-size fireplaces, archways, chimneys etc.'
        ],
        img360: brickAndStone
    },
    "HOUSE FRAMING WORKSPACE": {
        position: {
            largeScreen: {
                x: 402.5,
                y: 335.394
            },
            mobilePortrait: {
                x: 175.297,
                y: 254.61
            },
            mobileLandscape: {
                x: 318.703,
                y: 148.053
            }
        },
        learnMore: {
            label: 'Learn more about our program offerings.',
            link: "https://www.183training.com/construction-skills-programs/#courses"
        },
        size: 'Workshop #2 - 7,900 sq. ft.',
        description: `Workshop #2 is our largest workshop area and serves as a versatile, multi-use space. It’s home to our flagship Construction Craftwork apprenticeship, where students work on a range of skills, from setting up various types of scaffolding, to building forms, to creating structures from cement. 
        Trainees in the House Framing Construction Skills program can also use this space to build a full-size 1,800- to 2,000-square-foot home. After the house is built, we run our Residential Trim and Residential Handyman program from the inside the structure. Students in these programs will perform various tasks like installing baseboards, caulking, and painting. On top of that, the Brick and Stone trainees also use the house to practice bricking the front of a home, including around windows, doors, and columns. `,
        imgDirectory: "StructureForming",
        numberOfImgs: 14,
        img360: strcutureforming
    },
    "BRIDGE CONSTRUCTION WORKSPACE": {
        position: {
            largeScreen: {
                x: 432.672,
                y: 383.394
            },
            mobilePortrait: {
                x: 207.757,
                y: 272.323
            },
            mobileLandscape: {
                x: 329.042,
                y: 183.557
            }
        },
        size: 'Workshop #2 - 7,900 sq. ft.',
        description: `Workshop #2 is our largest workshop area and serves as a versatile, multi-use space.  This area is where our trainees can build a small-scale bridge and move the bridge beams with the use of an overhead crane. Students in our Bridge Construction program will also learn how to construct, install, and align footing forms, install spreaders and ties, and use tube and clamp scaffolding.`,
        learnMore: {
            label: 'Learn more about our Bridge Construction program.',
            link: 'https://www.183training.com/course/bridge-construction/'

        },
        imgDirectory: "Small-scaleBridge",
        numberOfImgs: 12,
        bulletPoints: [
            'This is our largest workshop areas.',
            'Our flagship Construction Craftwork Apprenticeship is taught in this area, students can set up various types of scaffolding, build forms and create structures from cement.',
            'Our trainees can build a full size 1,800 to 2,000 square foot home as a part of our House Framing Construction Skills Program.',
            'Once the house is built, we also run our Residential Trim and Residential Handyman program from the inside the structure.  The brick and stone apprentices also use the house as practice to brick the front of the home, including around windows doors and columns.',
            'Our trainees can also build a small-scale bridge in this area and are able to move the bridge beams with the use of our overhead crane.'
        ],
        img360: bridgeConstruction
    },
    "CEMENT FINISHER WORKSPACE": {
        position: {
            largeScreen: {
                x: 380.676,
                y: 274.633
            },
            mobilePortrait: {
                x: 143.546,
                y: 227.025
            },
            mobileLandscape: {
                x: 315.863,
                y: 106.09
            }
        },
        size: 'Workshop #3 - 5,300 sq. ft.',
        description: `Workshop #3 is the hub for our Cement Finisher apprenticeship. This is where students can mix, pour, and finish cement. We also train our students to use the powered ride-on trowel machine and the walk-behind power trowel for finishing concrete surfaces. We also have a concrete mixer available for smaller, on-site projects.`,
        learnMore: {
            label: 'Learn more about our Cement Finisher apprenticeship.',
            link: 'https://www.183training.com/course/cement-finisher-level-1/'
        },
        bulletPoints: [
            'Students can mix, pour, and finish cement as a part of our cement finisher apprenticeship.',
            'They can use the concrete mixer, for smaller on-site projects.',
            'Students are taught to use the powered ride on trowel machine and the walk behind power trowel for finishing concrete surfaces.'
        ],
        imgDirectory: "CementMixer",
        numberOfImgs: 4,
        img360: cementFinisher
    },
    "ASPHALT WORKSPACE": {
        position: {
            largeScreen: {
                x: 345.752,
                y: 352.523
            },
            mobilePortrait: {
                x: 148.49,
                y: 282.448
            },
            mobileLandscape: {
                x: 280.062,
                y: 148.684
            }
        },
        size: 'Workshop #4 - 5,300 sq. ft.',
        description: `Workshop #4 hosts our Roads and Asphalt Construction Skills program, where students learn to form, pour, and finish sidewalks and curbs. In this area, students can also learn how to grade and lay interlocking stone, as well as use the asphalt spreader over sand to simulate asphalt work.`,
        learnMore: {
            label: 'Learn more about these programs.',
            link: 'https://www.183training.com/construction-skills-programs/#courses'
        },
        bulletPoints: [
            'Our roads and asphalt construction skills programs are also taught in the workshop area.  Students form, pour and finish sidewalks and curbs.  Other aspects of the program include students learning to grade and lay interlocking stone, and other types of cement finishing techniques.  They are also taught to use the asphalt spreader over sand to simulate asphalt work.'
        ],
        imgDirectory: "Asphalt",
        numberOfImgs: 5,
        img360: asphalt
    },
    "SEWER + WATER MAIN WORKSPACE": {
        position: {
            largeScreen: {
                x: 382.789,
                y: 385.996
            },
            mobilePortrait: {
                x: 180.215,
                y: 289.69
            },
            mobileLandscape: {
                x: 297.304,
                y: 176.282
            }
        },
        size: 'Workshop #4 - 5,300 sq. ft.',
        description: `Workshop #4 hosts our Sewer and Water Main program, where students learn how to read blueprints, survey, use proper laser set up, and check benchmarks, levels, elevations, and grades. Students will also be able to use the mini excavator machine to excavate and install both PVC plastic and concrete pipes.`,
        imgDirectory: "MiniExcavator",
        numberOfImgs: 5,
        learnMore: {
            label: 'Learn more about our Cement Finisher apprenticeship.',
            link: 'https://www.183training.com/course/cement-finisher-level-1/'
        },
        bulletPoints: [
            'Students can mix, pour, and finish cement as a part of our cement finisher apprenticeship.',
            'They can use the concrete mixer, for smaller on-site projects.',
            'Students are taught to use the powered ride on trowel machine and the walk behind power trowel for finishing concrete surfaces.'
        ],
        img360: miniexcavator
    },
    "TILE SETTER WORKSPACE": {
        position: {
            largeScreen: {
                x: 362.51,
                y: 484.434
            },
            mobilePortrait: {
                x: 200.033,
                y: 352.135
            },
            mobileLandscape: {
                x: 267.015,
                y: 234.375
            }
        },
        size: 'Outdoor Workspace #1 - 800 sq. ft.',
        description: `Our fully-enclosed Outdoor Workspace #1 is dedicated to our Residential Tile Setter program, where we teach our students how to build shower stalls and use the Schluter Waterproofing System. They can also practice installing wall and flooring tiles and backsplashes.`,
        learnMore: {
            label: 'Learn more about our Tile Setter program.',
            link: 'https://www.183training.com/course/tile-setting/'
        },
        bulletPoints: [
            'Fulling enclosed workspace that is dedicated to our residential tile setter program.',
            'Students build shower stalls and are taught, the Schluter Waterproofing System',
            'They are able to practice installing wall and flooring tile as well as backsplashes.',
            'The size of this workplace area is approximately 800 sq. ft.',
        ],
        imgDirectory: "TileSettingRoom",
        numberOfImgs: 4,
        img360: tileSetter
    },

    "TUNNEL TRAINING + RESCUE FACILITY": {
        position: {
            largeScreen: {
                x: 242.695,
                y: 371.01
            },
            mobilePortrait: {
                x: 95.764,
                y: 325.785
            },
            mobileLandscape: {
                x: 212.152,
                y: 141.874
            }
        },
        description: "After the Hogg’s Hollow accident of 1960, tunnel rescue has been a huge concern in labour safety. Despite this concern, there continues to be many injuries and fatalities in tunnel construction. Given the importance of properly trained emergency personnel, we are building an 8,000-square-foot Tunnel Training and Rescue Facility, which will be the first of its kind in North America. It will provide a real underground tunnel and shaft working environment to our trainees and industry partners for specialized rescue training when it starts in 2022. It contains a shaft that is nine meters around and six meters deep, leading to the tunnel. The tunnel itself is three meters in diameter and 100 meters long. ",
        bulletPoints: [
            'First of its kind in Canada',
            '8000 sq. ft building',
            'Contains a 9-meter diameter shaft that is 6 meters deep, which leads to the tunnel.',
            'The tunnel is 3-meter in diameter and is 100 meters long.',
            'The facility will be used by our trainees as well as industry partners for specialized rescue training.'
        ],
        imgDirectory: "TunnelTrainingandRescueFacility",
        numberOfImgs: 4,
        img360: tunnelRescue
    },
    "OUTDOOR WORKSPACE #2": {
        position: {
            largeScreen: {
                x: 286.831,
                y: 430.971
            },
            mobilePortrait: {
                x: 139.963,
                y: 345.83
            },
            mobileLandscape: {
                x: 229.116,
                y: 187.344
            }
        },
        description: "Outdoor Workspace #2 is where students can learn key hands-on skills in outdoor construction – all in a safe and controlled environment. It hosts our Utilities, Landscaping, and Drain and Concrete courses. Students learn small machine operation on the mini excavator, skid steer, scissor lift, and 0-8 ton boom (mobile crane).",
        imgDirectory: "MobileCrane",
        numberOfImgs: 1,
        img360: mobileCrane,
        learnMore: {
            label: 'Learn more about our course offerings.',
            link: 'https://www.183training.com/construction-skills-programs/#courses'
        },
        bulletPoints: [
            'In this area students can complete various types of outdoor construction skills training',
            'They are taught small machine operation on the Mini excavator, Skid Steer, Scissor Lift, 0-8 Ton Boom (Mobile crane)',
            'Our utilities, landscaping and concrete and drain courses are also taught in this space.',
            'These outdoor training areas are a great way for students to gain on the job experience in a safe and controlled environment.'
        ],
    },
    "SIMULATED HIGH RISE BUILDING": {
        position: {
            largeScreen: {
                x: 99.883,
                y: 579.631
            },
            mobilePortrait: {
                x: 80.982,
                y: 489.922
            },
            mobileLandscape: {
                x: 85.371,
                y: 247.165
            }
        },
        size: 'Outdoor Workspace #3',
        description: `Fully equipped with a tower crane and classroom, our Outdoor Workspace #3 hosts both our High Rise Forming and Rodman Skills programs. This workspace houses a three-story simulated high-rise building, where students learn how to safely fly forms, practice safe hoisting and rigging, and learn how to tie steel reinforcement rods.`,
        learnMore: {
            label: 'Learn more about these programs.',
            link: 'https://www.183training.com/construction-skills-programs/#courses'
        },
        imgDirectory: "SimulatedHighRiseBuilding",
        numberOfImgs: 14,
        img360: highRiseFormingRodman
    },
}


const chapters = [
    {
        "name": "WELCOME",
        "index": "00",
        "src": `${assetsPath}thumbnails/welcome.png`,
        "timestamp": 0
    },
    {
        "name": "CLASSROOMS",
        "index": "01",
        "src": `${assetsPath}thumbnails/classroom.png`,
        "timestamp": 34
    },
    {
        "name": "WELDING ROOM",
        "index": "02",
        "src": `${assetsPath}thumbnails/welding.png`,
        "timestamp": 43.5
    },
    {
        "name": "HOUSE FRAMING",
        "index": "03",
        "src": `${assetsPath}thumbnails/HouseFarming.png`,
        "timestamp": 80
    },
    {
        "name": "CONSTRUCTION CRAFT WORKER (CCW)", 
        "index": "04",
        "src": `${assetsPath}thumbnails/Bridge.png`,
        "timestamp": 89
    },
    {
        "name": "BRICK+STONE",
        "index": "05",
        "src": `${assetsPath}thumbnails/brick.png`,
        "timestamp": 120
    },
    {
        "name": "CEMENT FINISHER",
        "index": "06",
        "src": `${assetsPath}thumbnails/CEMENTFINISHING.png`, 
        "timestamp": 148
    },
    {
        "name": "ASPAHLT SPREADER",
        "index": "07",
        "src": `${assetsPath}thumbnails/ASPAHLT.png`,
        "timestamp": 195
    },
    {
        "name": "SEWER+WATER MAIN",
        "index": "08",
        "src": `${assetsPath}thumbnails/MINIEXCAVATOR.png`,
        "timestamp": 202
    },
    {
        "name": "OUTDOOR WORKSPACE",
        "index": "09",
        "src": `${assetsPath}thumbnails/OUTDOORWORKSPACES.png`,
        "timestamp": 212
    },
]


export { locations, chapters }

